package fr.manyverse.app.domain.model

import kotlinx.serialization.Serializable

/**
 * Mode de gestion des personnages choisi par le MJ pour un univers.
 *
 * - [FREE_CONSTRUCTION] : les joueurs construisent librement leur fiche (onglet Caractéristiques).
 * - [TEMPLATE] : les joueurs partent d'un template prédéfini (fonctionnalité à venir).
 */
@Serializable
enum class CharacterMode {
    FREE_CONSTRUCTION,
    TEMPLATE
}
